import Bee from '@beefree.io/sdk';
import angular from 'angular';

angular.module("app")

    .service('BeeService', ['$http', '$q', 'Restangular', '$rootScope', '$timeout', '$filter', function ($http, $q, Restangular, $rootScope, $timeout, $filter) {

        let endpoint = "https://auth.getbee.io/apiauth";

        let config_email = {
            client_id: "958cfa50-f6d0-470f-bdfa-34ab8a4862fa", // Enter your client id
            client_secret: "a3pX7dmiSzlvRLDge4Qc6wqBqZ5KnDT99ghuzHvqprRDWSQwilQf", // Enter your secret key
            grant_type: "password" // Do not change
        };

        let config_html = {
            client_id: "826b6a37-1d11-4725-94ab-cc67b493d186", // Enter your client id
            client_secret: "Tn1FP7B9G1oIetrsdVT7rvKgct2pDCSduvbWGYJmZ4a8XmW1syc4", // Enter your secret key
            grant_type: "password" // Do not change
        };




        let savedDeferred: any = undefined;
        $filter('translate')('general.deleted_success')
        let mergeTags = [

            { name: $filter('translate')('variables.templates.person_name'),  value: '[PERSON_NAME]', sample: 'Rodolfo', category: 'Person' },
            { name: $filter('translate')('variables.templates.person_surname'), value: '[PERSON_SURNAME]', sample: 'Rubio', category: 'Person' },
            { name: $filter('translate')('variables.templates.person_lastname'), value: '[PERSON_LASTNAME]', sample: 'Maestre', category: 'Person' },
            { name: $filter('translate')('variables.templates.person_fullname'), value: '[PERSON_FULLNAME]', sample: 'Rodolfo Rubio Maestre', category: 'Person' },
            { name: $filter('translate')('variables.templates.person_emails'), value: '[PERSON_EMAILS]', sample: 'email1@gmail.com, email2@gmail.com', category: 'Person' },
            { name: $filter('translate')('variables.templates.person_phones'), value: '[PERSON_PHONES]', sample: '989 999 999, 911 000 000', category: 'Person' },
            { name: $filter('translate')('variables.templates.position_names'), value: '[POSITIONS_NAMES]', sample: 'Concejal del PP, Presidente de la comunidad de Madrid', category: 'Person' },

            { name: $filter('translate')('variables.templates.position_article'), value: '[POSITION_ARTICLE]', sample: 'al', category: 'Person' },
            { name: $filter('translate')('variables.templates.person_treatment'), value: '[PERSON_TREATMENT]', sample: 'Excelentísimo señor', category: 'Person' },
            { name: $filter('translate')('variables.templates.person_treatment_short'), value: '[PERSON_TREATMENT_SHORT]', sample: 'Exct Sr', category: 'Person' },

            { name: $filter('translate')('variables.templates.group_name'), value: '[GROUP_NAME]', sample: 'Alcaldía de Madrid', category: 'Position' },
            { name: $filter('translate')('variables.templates.position_name'), value: '[POSITION_NAME]', sample: 'Concejal del PP', category: 'Position' },
            { name: $filter('translate')('variables.templates.position_name_short'), value: '[POSITION_NAME_SHORT]', sample: 'Concejal', category: 'Position' },
            { name: $filter('translate')('variables.templates.position_treatment'), value: '[POSITION_TREATMENT]', sample: 'Ilustrisimo doctor', category: 'Position' },
            { name: $filter('translate')('variables.templates.position_treatment_short'), value: '[POSITION_TREATMENT_SHORT]', sample: 'Ilus dr', category: 'Position' },
            { name: $filter('translate')('variables.templates.institution'), value: '[INSTITUTION]', sample: 'Arzobispado de Granada', category: 'Position' },
            { name: $filter('translate')('variables.templates.institution_or_group_name'), value: '[INSTITUTION_OR_GROUP_NAME]', sample: 'Arzobispado de Granada || Iglesia católica', category: 'Position' },

            { name: $filter('translate')('variables.templates.militar_position_name'), value: '[MILITAR_POSITION_NAME]', sample: 'Cabo Primero de la brigada de montaña', category: 'Position_militar' },
            { name: $filter('translate')('variables.templates.militar_position_name_short'), value: '[MILITAR_POSITION_NAME_SHORT]', sample: 'Cabo Primero', category: 'Position_militar' },
            { name: $filter('translate')('variables.templates.militar_position_treatment'), value: '[MILITAR_POSITION_TREATMENT]', sample: 'Excelentísimo señor', category: 'Position_militar' },
            { name: $filter('translate')('variables.templates.militar_position_treatment_short'), value: '[MILITAR_POSITION_TREATMENT_SHORT]', sample: 'Exc sr', category: 'Position_militar' },

            { name: $filter('translate')('variables.templates.event_name'), value: '[EVENT_NAME]', sample: 'San Isidro 2025', category: 'Event' },
            { name: $filter('translate')('variables.templates.event_date'), value: '[EVENT_DATE]', sample: '03/05/2025', category: 'Event' },
            { name: $filter('translate')('variables.templates.event_location'), value: '[EVENT_LOCATION]', sample: 'Palacio de la Aljafería', category: 'Event' },

            { name: $filter('translate')('variables.templates.accreditation'), value: '[ACCREDITATION]', sample: 'Coordinador técnico del evento', category: 'Event' },
            { name: $filter('translate')('variables.templates.space_name'), value: '[SPACE_NAME]', sample: 'Pabellón deportivo', category: 'Event' },
            { name: $filter('translate')('variables.templates.full_guest_space'), value: '[FULL_GUEST_SPACE]', sample: 'Pabellón deportivo -  grada frontal - fila 1, asiento 2', category: 'Event' },

            { name: $filter('translate')('variables.templates.signature'), value: '[SIGNATURE]', sample: 'Firma del correo ', category: 'Mail' },

            // { name: 'TOKEN', value: '[TOKEN]', sample: 'Token', category: 'Event' },
            // { name: 'ID de imagen', value: '[EVENT_IMG_ID]', sample: '123', category: 'Image' },
            // { name: 'EVENT_IMG_GUID', value: '[EVENT_IMG_GUID]', sample: '321wqdsadzaxz ', category: 'Image' },
            // { name: 'EVENT_GUEST_TRACK', value: '[EVENT_GUEST_TRACK]', sample: '?', category: 'Image' },

        ];

        let specialLinks = [

            { type: $filter('translate')('variables.templates.invitation'), label: $filter('translate')('variables.templates.accept'), link: '[LINK_ACCEPT]' },
            { type: $filter('translate')('variables.templates.invitation'), label: $filter('translate')('variables.templates.reject'), link: '[LINK_REJECT]' },
            { type: $filter('translate')('variables.templates.invitation'), label: $filter('translate')('variables.templates.delegate'), link: '[LINK_DELEGATE]' },

            { type: $filter('translate')('variables.templates.registration'), label: $filter('translate')('variables.templates.user_registration_link'), link: '[USER_REGISTRATION_LINK]' },
            { type: $filter('translate')('variables.templates.registration'), label: $filter('translate')('variables.templates.link_unsuscribe'), link: '[LINK_UNSUBSCRIBE]' },
            { type: $filter('translate')('variables.templates.registration'), label: $filter('translate')('variables.templates.user_registration_qr'), link: '[USER_REGISTRATION_QR]' },
         // { type: $filter('translate')('variables.templates.registration'), label: 'Token', link: '[TOKEN]' },

            { type: $filter('translate')('variables.templates.other_links'), label: $filter('translate')('variables.templates.event_image'), link: '[EVENT_IMG]' },
            { type: $filter('translate')('variables.templates.other_links'), label: $filter('translate')('variables.templates.link_check_bot'), link: '[LINK_CHECK_BOT]' },
            { type: $filter('translate')('variables.templates.other_links'), label: $filter('translate')('variables.templates.event_guest_track'), link: '[EVENT_GUEST_TRACK]' }

        ];

        // Gestionamos los merge tag
        let priorityOrder = {
            'Person': 1,
            'Position': 2,
            'Position_militar': 3,
            'Event': 4
        };

        // Ordenamos los Merge Tag
        mergeTags = mergeTags.sort(function (a, b) {
            let prioridadA = priorityOrder[a.category] || 999;
            let prioridadB = priorityOrder[b.category] || 999;

            if (prioridadA !== prioridadB) {
                return prioridadA - prioridadB;
            }

            return a.name.localeCompare(b.name);
        });

        let config_instance: any = {
            container: 'bee-plugin-container',
            language: 'es-ES',
            mergeTags: mergeTags,
            specialLinks: specialLinks,
            onSave: function (jsonFile, htmlFile) {
                if(savedDeferred !== undefined) {
                    savedDeferred.resolve({
                        json: jsonFile,
                        html: htmlFile
                    });
                }
            }
        };
        
        let bee;
        let token = undefined;
        
        return {
            start: function (template, config: string | null = null) {
                $http.post(`api/mailings/bee/login`, {}).then(response => {
                    bee = new Bee(response.data);
                    Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
                        // Si no tiene cuerpo y empleo activado, deshabilitamos los tags militares
                        if (!results.military_groups_enabled) config_instance.mergeTags = mergeTags.filter(m => m.category != 'Position_militar');
                        config_instance.uid = 'stela-' + results.uid;
                        bee.start(config_instance, template);
                    }, function (response) {
                    });
                 });

            },
            reload: function (template, config = null) {
                this.start(template,config);
            },
            save: function () {
                savedDeferred = $q.defer();
                let promise = savedDeferred.promise;
                bee.save();
                return promise;
            },
        };
    }]);
